import {
  Subject,
  switchMap,
  map,
  filter,
  take,
  of,
  pluck,
  interval,
  tap,
  merge,
  BehaviorSubject,
  catchError,
  EMPTY,
} from "rxjs";

import {webSocket} from 'rxjs/webSocket'
import {getPushToken} from "@/api/push";
import { ANY_EVENT } from "@/services/push/events";


const tpBaseUrl = process.env.VUE_APP_WSS_URL;
const init$ = new Subject()
const initConfig$ = new BehaviorSubject()
const currentWS$ = new BehaviorSubject(null)
const outerEvent$ = new Subject()
const innerPublisher$ = new Subject()
export const mergedEvent$ = merge(outerEvent$, innerPublisher$)
const initConfig = null;

merge(
  init$.pipe(filter(x => x.type === 'init'), take(1)),
  init$.pipe(filter(x => x.type === 'reconnect', switchMap(() => initConfig.pipe(take(1)))))
).subscribe(x => initConfig$.next(x))

// create new ws
initConfig$.pipe(
  filter(x => x && x.authBy && x[x.authBy]),
  // disconnect last one
  tap(() => currentWS$.pipe(
    take(1),
    filter(x => x),
    tap(x => {
      x.webSocket$.complete()
      console.log(`PUSH EVENT: Close`)
      x.$hearBeat.unsubscribe()
    }),
    catchError(() => ''),
  ).subscribe()),
  // connect
  switchMap(config => of('').pipe(
    switchMap(() => getPushToken()),
    pluck('res', 'data', 'data'),
    map(x => [config, webSocket(`${tpBaseUrl}?token=${x}`)]))),
  switchMap(([x, webSocket$]) => {
    // verify
    webSocket$.next({
      action: "verify",
      [x.authBy]: x[x.authBy]
    })
    // heartbeat
    const $hearBeat = interval(1000 * 60 * 4).subscribe(() => webSocket$.next({"action": "heartbeat"}))
    //
    currentWS$.next({webSocket$, $hearBeat})
    return webSocket$.pipe(
      filter(x => x.code === 200 && (x.data.type === 2 || x.data.type === 1)),
      map((x) => {
        let dataType = ANY_EVENT
        if (x.data.data && x.data.data.event) {
          dataType = x.data.data.event; 
          x.data.data.dataType = dataType;
        }
        return {data: {dataType: dataType}, params: x}
      }),
      // pluck('data', 'data'),
      catchError(x => {
        // error handler
        console.error(`PUSH EVENT webSocket$:`, x)
        return EMPTY
      })
    )
  }),
).subscribe(x => outerEvent$.next(x), null, () => {
  console.log(`PUSH EVENT: Try to reconnect`)
  init$.next({type: 'reconnect'})
})

// config : {authBy: 'x-auth-token', 'x-auth-token': xxx} or (trip){authBy: 'client_id', 'client_id': xxx}
export function initPush(config) {
  init$.next({
    ...config,
    type: 'init'
  })
}

const eventsCache = {}
function initEvent(event) {
  if(!eventsCache[event]) {
    eventsCache[event] = mergedEvent$.pipe(
      filter(x => x.data.dataType === event),
      tap(x => console.log(`PUSH EVENT: ${event}`, x))
    )
  }
}
/**
 *

 * @function filterEventOb$
 * @param event
 * @return Observable
 * @warning Do not forget to unsubscribe it when the component destroyed.
 * @example
 *
 * import {MISS_CALL} from "@/services/push/events";
   import {filterEventOb$} from "@/services/push/index";

   ...
   filterEventOb$(MISS_CALL).pipe(
   ...
   ).subscribe(x => {
      ...
     })

 '
   Data Struct
   initValue: null
   Pls see events.js
 */
export function filterEventOb$(event) {
  initEvent(event)
  return eventsCache[event]
}

export function publish(type, data) {
  innerPublisher$.next({
    dataType: type,
    ...data
  })
}
